import React from "react";
import {useTranslation} from "react-i18next";
import {Preloader} from "../Preloader";
import {inject, observer} from "mobx-react";
import cn from "classnames";
import {color} from "constants/color.consts";

export const Button = inject("store")(
  observer(
    ({
      store: {auth},
      name,
      disabled,
      loading,
      onClick,
      style,
      addClass,
      type,
      img,
      icon,
      imgRight,
      iconRight,
    }) => {
      const {btnLoading} = auth;
      const {t} = useTranslation();
      const styles = {
        background: disabled && !btnLoading && !loading && color.lightGray,
        color: disabled && color.midGray,
        ...style,
      };

      return (
        <button
          disabled={btnLoading || disabled || loading}
          style={styles}
          className={cn("btn", {[addClass]: !!addClass})}
          onClick={onClick}
          type={type || "button"}
        >
          {btnLoading || loading ? (
            <Preloader addClass="btn-loader" size="default" />
          ) : (
            <>
              {(img && <img src={img} alt="" />) || icon}
              {t(name)}
              {(imgRight && <img src={imgRight} alt="" />) || iconRight}
            </>
          )}
        </button>
      );
    }
  )
);
